var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c(
      "div",
      { staticClass: "is-weiXin-tip hidden", class: { show: _vm.is_weixn() } },
      [
        _c("img", {
          staticClass: "tip-open",
          attrs: {
            src: require("@/assets/case-share-detail/what_tip.png"),
            alt: ""
          }
        })
      ]
    ),
    _c("div", { staticClass: "content-wrap" }, [
      _c("div", { staticClass: "case-box" }, [
        _c("div", { staticClass: "case-tit flex flex-space-between" }, [
          _c("h5", [
            _vm._v("案件协作 "),
            _c("label", [_vm._v(_vm._s(_vm.detail.bizTypeLabel))])
          ]),
          _vm._v(" "),
          _c("i", { class: [_vm.statusText === "待接单" && "green-color"] }, [
            _vm._v(_vm._s(_vm.statusText))
          ])
        ]),
        _c("div", { staticClass: "case-texts" }, [
          _c("p", [
            _c("label", [_vm._v("详细需求")]),
            _vm._v(" "),
            _c("span", { staticClass: "fs15" }, [
              _vm._v(_vm._s(_vm.detail.info))
            ])
          ]),
          _c("p", [
            _c("label", [_vm._v("发布时间")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.detail.createTime))])
          ]),
          _c("p", [
            _c("label", [_vm._v("协作地区")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.detail.provinceName) +
                  "-" +
                  _vm._s(_vm.detail.regionName)
              )
            ])
          ]),
          _c("p", [
            _c("label", [_vm._v("预算金额")]),
            _vm._v(" "),
            _c("span", { staticClass: "money" }, [
              _vm._v("¥" + _vm._s(_vm.priceYuan(_vm.detail.amount)))
            ])
          ]),
          _c("p", [
            _c("label", [_vm._v("接单响应")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "lawyers" },
              [
                _vm._l(_vm.detail.jdLawyerList, function(imgSrc) {
                  return _c("img", {
                    key: imgSrc.id,
                    attrs: { src: imgSrc.jdLawyerAvatar }
                  })
                }),
                _vm._v(
                  " 已有" +
                    _vm._s(_vm.detail.jdLawyerList.length) +
                    "位律师响应"
                )
              ],
              2
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "case-box lawyers-box" }, [
        _c("ul", { staticClass: "lawyer-infos" }, [
          _c(
            "li",
            { staticClass: "flex flex-space-between flex-align-center" },
            [
              _c("div", { staticClass: "lawyer-text" }, [
                _c("img", {
                  staticClass: "lawyer-header",
                  attrs: { src: _vm.detail.fbLawyerAvatar }
                }),
                _c("div", [
                  _c("p", { staticClass: "lawyer-name" }, [
                    _vm._v(_vm._s(_vm.detail.fbLawyerName || "暂无") + " "),
                    _c("label", { staticClass: "fs12 " }, [_vm._v("发单律师")])
                  ]),
                  _vm._m(0)
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._m(1)
    ]),
    _c("div", { staticClass: "footers" }, [
      _c("button", { on: { click: _vm.openApp } }, [_vm._v("立即前往APP")]),
      _c("p", [
        _vm._v("您还没安装法临律师端APP？请点击 "),
        _c("a", { on: { click: _vm.buttonDownload } }, [_vm._v("立即下载")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "lawyer-icon",
        attrs: { src: require("@/assets/imgs/share-page/icons.png") }
      }),
      _vm._v("已通过法临官方认证 ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "case-box con-prompt" }, [
      _c("p", { staticClass: "fs14 con-prompt-tit" }, [_vm._v("法临温馨提示")]),
      _c("div", { staticClass: "fs12 con-prompt-texts" }, [
        _c("p", [
          _vm._v(
            "1.法临仅为双方提供信息展示和沟通平台，请自行确认对方协作信息的真实性后再进行合作，避免给您带来不必要的损失"
          )
        ]),
        _c("p", [
          _vm._v(
            "2.协作费用由发单、接单双方律师自主协商并自行完成支付， 法临不收取也不担保任何费用"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }